import { useEffect, useState } from "react";

const SidebarIconItem = ({ item, activePath, navigate }) => {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(true);
  }, [activePath]);

  if (!item.visible()) return null;

  const isActive = activePath === item.path;

  return (
    <li
      className={`nav-items p-1 px-3 ${
        isActive && "nav-items-active"
      } nav-items-dd`}
    >
      <div
        className="d-flex justify-content-between align-items-center"
        onClick={() => {
          if (item.subItems) {
            navigate(item.subItems?.[0]?.path);
          } else {
            navigate(item.path);
          }
          setOpen(!open);
        }}
      >
        <label className="w-100 cursor_pointer p-1">
          <item.icon
            fill={isActive ? "#7065E4" : "#B0B3C7"}
            height="18px"
            width="18px"
          />
        </label>
      </div>
    </li>
  );
};

export default SidebarIconItem;
